import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";

function wrap(callback, n) {
  var t = 0;
  return function () {
    if (t++ >= n) {
      t = 0;
      callback();
    }
  };
}

var Ticker = /*#__PURE__*/function () {
  function Ticker(app) {
    _classCallCheck(this, Ticker);

    this.app = app;
    this.timer = null;
    this.callbacks = [];
  }

  _createClass(Ticker, [{
    key: "attach",
    value: function attach(callback) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var useSafe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var thisArg = arguments.length > 3 ? arguments[3] : undefined;

      if (thisArg) {
        callback = callback.bind(thisArg);
      }

      if (useSafe) {
        callback = this.app.safe(callback);
      }

      this.callbacks.unshift(n ? wrap(callback, n) : callback) - 1;
    }
  }, {
    key: "start",
    value: function start() {
      var _this = this;

      if (this.timer === null) {
        this.timer = setInterval(function () {
          return _this.callbacks.forEach(function (cb) {
            if (cb) cb();
          });
        }, 30);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }]);

  return Ticker;
}();

export { Ticker as default };